var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-button"},[_c('button',{staticClass:"md-button md-raised",style:('color:' +
      (_vm.styleButton && _vm.styleButton.color ? _vm.styleButton.color : '#fff') +
      ';background:' +
      (_vm.styleButton && _vm.styleButton.background
        ? _vm.styleButton.background
        : '#1CAB36') +
      ';border:' +
      (_vm.styleButton && _vm.styleButton.border ? _vm.styleButton.border : '') +
      (_vm.disabled ? ';opacity: 0.5; cursor: not-allowed' : '') +
      (_vm.styleButton && _vm.styleButton.other ? ';' + _vm.styleButton.other : '')),attrs:{"disabled":_vm.disabled,"type":"button","md-menu-trigger":_vm.menuTrigger},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"md-button-content"},[(_vm.icon)?_c('i',{staticClass:"md-icon md-icon-font",style:('color:' +
          (_vm.styleIcon && _vm.styleIcon.color
            ? _vm.styleIcon.color
            : _vm.styleButton?.color || '#fff'))},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }